import { createSlice } from "@reduxjs/toolkit";
import { FailedUserFetchResponse } from "../../../constants/error_messages";
import { SMS } from "../../../constants/reducer_names";
import { getDidNumber, getDidPurchase,getDidPurchaseList } from "../../api/sms";
import * as helper from "../../helpers/sms";

const initialState = {
  loading: false,
  setloading: false,
  isModelOpen: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
  smsList: [] as any,
  smsData: [] as any,
  smsDetails: {
    pid: 0,
    user_id: 0,
    type: "",
    city: "",
    your_number: 0,
    callFlowId: "",
    recording: 0,
    queueName: "",
    supervisorName: "",
    web_id:"",
    isCall: 0,
    isSms: 0,
    createdAt: "",
    smsThreshold: 24,
    aliasName: "",
    outboundSms: 0,
  } as any,
  search: "" as string,
  checkChanges: false,
  toEnableAddNumber: false,
};
const sms = createSlice({
  name: SMS,
  initialState,
  reducers: {
    smsList: (state, { payload }) => {
      state.smsList = payload;
    },
    smsData: (state, { payload }) => {
      state.smsData = payload;
    },
    isModelOpen: (state, { payload }) => {
      state.isModelOpen = payload;
    },
    smsDetails: (state, { payload }) => {
      state.smsDetails = {
        pid: 0,
        user_id: 0,
        type: "",
        city: "",
        your_number: 0,
        callFlowId: "",
        recording: 0,
        queueName: "",
        supervisorName:"",
        knowledgeBasedId:'',
        isCall: 0,
        isSms: 0,
        createdAt: "",
        smsThreshold: 24,
        aliasName: "",
        outboundSms: 0,
      };
    },
    setSmsDetails: (state, { payload }) => {
      state.smsDetails = {...state.smsDetails,...payload};
    },
    checkChanges: (state, { payload }) => {
      state.checkChanges = payload;
    },
    statusData: (state, { payload }) => {
      state.smsList.length = 0;
      state.smsList = payload;
    },
    aliasName: (state, { payload }) => {
      state.smsDetails.aliasName = payload;
    },
    smsThreshold: (state, { payload }) => {
      state.smsDetails.smsThreshold = payload;
    },
    queueName: (state, { payload }) => {
      state.smsDetails.queueName = payload;
    },
    supervisorName: (state, { payload }) => {
      state.smsDetails.supervisorName = payload;
    },
    knowledgeBased: (state, { payload }) => {
      state.smsDetails.knowledgeBasedId = payload;
    },
    search: (state, { payload }) => {
      state.search = payload;
      if (payload.length < 1) {
        helper.resetFilter(state);
      } else {
        if (state.smsData.length > 0) {
          state.smsList = helper.smsSearchData(state.smsData, payload);
        }
      }
    },
    outboundSms: (state, { payload }) => {
      state.smsDetails[payload] = state.smsDetails[payload] === 1 ? 0 : 1;
    },
    toEnableAddNumber: (state, { payload }) => {
      state.toEnableAddNumber = payload;
    },
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(getDidPurchaseList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDidPurchaseList.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.smsList = payload.data.getDidPurchaseDetails;
        state.smsData = payload.data.getDidPurchaseDetails;

        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }
      state.loading = false;
    });
    builder.addCase(getDidPurchaseList.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      state.loading = false;
    });

    builder.addCase(getDidPurchase.pending, (state) => {
      state.setloading = true;
    });
    builder.addCase(getDidPurchase.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        const number = payload?.data?.getDidNumberlist[0].your_number;
        state.smsDetails = payload?.data?.getDidNumberlist[0];
        state.smsDetails.your_number = `${number
          .toString()
          .substring(0, 2)} ${number.toString().substring(2, 5)} ${number
          .toString()
          .substring(5, 8)} ${number.toString().substring(8, 12)}`;
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      }
      state.setloading = false;
    });
    builder.addCase(getDidPurchase.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.message ?? FailedUserFetchResponse;
      state.setloading = false;
    });
  },
});

export const smsListAction = sms.actions;
export default sms.reducer;
